export default __webpack_public_path__ + "static/12-e700aa109c6b13168b4d96bf4c7f219f.svg";